<template>
    <DateRangePicker :id="id" @update:date="handleRangeDate" />
    <Button v-if="show && ($can(abilities.CREATE_EXPENSE_OFFICE) && $can(abilities.CREATE_EXPENSE_REPORT))" btn-class="btn-md" type="new" btn-text="expenses.file" @click="openExpenseFileModal"/>
    <Button v-if="back" icon-class="fas fa-backspace" btn-class="btn-sm mb-2" type="cancel" btn-text="crm.back" @click="router.go(-1)"/>
</template>
<script setup>
import DateRangePicker from "@/components/DateRangePicker.vue";
import Button from "@/components/Button.vue";
import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import abilities from "@/composables/abilities";

const store = useStore()
const router = useRouter()

const props = defineProps({
  id: {type: String, default: 'kt_td_picker_button'},
  show: {type: Boolean, default: true},
  back: {type: Boolean, default: true},
})

const start_date = defineModel('start_date')
const end_date = defineModel('end_date')


function handleRangeDate (range) {
  start_date.value = range.start_date
  end_date.value = range.end_date
}

function openExpenseFileModal(){
  $('#expense_file_modal').modal('toggle')
}

onMounted(() => {
  store.dispatch("user/loadUsers")
})
</script>
<style scoped>
</style>
  